import axios from 'axios';
import user from '../utils/user';

export default {

  async createBilletLoose(body) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/billets/loose`,
        body,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckoutLoose(body) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/checkouts/loose`,
        body,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
